import { SUBSCRIPTION_STATUS } from '../constants';
import type { CurrentMerchantState } from '../reducers/currentMerchant';

type SubscriptionInfo = Pick<
  CurrentMerchantState,
  'subscriptionStatus' | 'trialEndsOn'
>;

export const isPaidMerchant = ({
  currentMerchant,
}: {
  currentMerchant?: SubscriptionInfo | null;
}): boolean =>
  [SUBSCRIPTION_STATUS.ACTIVE, SUBSCRIPTION_STATUS.NON_RENEWING].includes(
    currentMerchant?.subscriptionStatus ?? ''
  ) || !currentMerchant?.trialEndsOn;
